var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cant_play_msg"},[_c('p',[_vm._v("Sorry! this browser doesn't support the format used in the player")])])}]

export { render, staticRenderFns }